import React from 'react';

import { useRemoveOnSiteWorkEventMutation } from 'generated/graphql';


export function useRemoveOnSiteWorkEvent() {
  const [
    fnMutate,
    tuple
  ] = useRemoveOnSiteWorkEventMutation({
    refetchQueries: []
  });
  const fnWrappedMutate = React.useCallback(
    async (id: string) => {
      await fnMutate({
        variables: {
          id
        }
      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
